import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Countdown from '../../utils/countdown';
import Playlist from '../../models/playlist';

class LeaveBehindList extends Component  {

    constructor(props) {

        super(props);

        this.state = { countdown: props.countdown };

        this.countdownInstance = Countdown({
            seconds: props.countdown,
            signal: (seconds) => this.setState({ countdown: seconds }),
            complete: () => props.onSelectItem(props.playlist.getNextItem()),
        });

    }

    componentWillUnmount() {

        if (this.countdownInstance) {

            this.countdownInstance.cancel();

        }

    }

    render() {

        const { playlist, onSelectItem } = this.props;
        const { countdown } = this.state;

        const next = playlist.getNextItem();
        const selected = playlist.getSelectedItem();

        return (
            <div className="leave-behind-playlist">
                {
                    playlist.items.map((item) => {

                        const isSelected = item.contentId === selected.contentId;
                        const isNext = item.contentId === next.contentId;
                        return (
                            <div key={item.contentId} onClick={() => onSelectItem(item)} className="leave-behind-playlist-item">
                                <div className="image">
                                    <img src={item.image.src} alt={item.title} />
                                </div>
                                <div className="information">
                                    <h1 className="title">
                                        { item.tags.statcast ? (<span className="leave-behind-tag statcast">Statcast &trade;</span>) : null }
                                        {item.title}
                                    </h1>
                                    <small>| {item.duration}</small>
                                </div>
                                <div className="actions">
                                    { isNext ? (<small className="countdown">Next in: {countdown}</small>) : null  }
                                    { isSelected ? <i className="media-icon media-icon--recap"></i> : <i className="media-icon media-icon--play"></i> }
                                </div>
                            </div>
                        );

                    })
                }
            </div>
        );

    }

}

LeaveBehindList.propTypes = {
    playlist: PropTypes.instanceOf(Playlist),
    countdown: PropTypes.number,
    onSelecItem: PropTypes.func,
};

LeaveBehindList.defaultProps = {
    playlist: new Playlist([]),
    onSelectItem: () => null,
    countdown: 7,
};

export default LeaveBehindList;
